import { useEffect, useMemo, useRef, useState } from 'react';
import { throttle } from 'lodash-es';
import { FILTER_WIDTH } from './_config';
import {
  SEGMENT_FLOAT_STICKY_SYNC_EVENT,
  type ISegmentFloatStickySyncDetail,
} from '@/pages/dashboard/utils/segmentFloatStickySync';

// const FILTER_WIDTH = 320;
const FILTER_HEIGHT = 46;
const BUTTON_HEIGHT = 46;
const PAGE_PADDING = 24;
const CARD_PADDING = 20;
const SPLIT_WITH = 2;
const DEFAULT_MENU_WIDTH = 250;
const SCROLL_BAR_WIDTH = 10;

const clientWidth = document.documentElement.clientWidth;
const defaultContentWidth = clientWidth - DEFAULT_MENU_WIDTH - SPLIT_WITH;

function getOffset(element: HTMLElement) {
  if (!element) {
    return {};
  }
  try {
    const x = element.getBoundingClientRect();
    return {
      top: x.top,
      width: x.width,
      height: x.height,
      left: x.left
    };
  } catch (_) {
    return {};
  }
}

export default (props: any) => {
  const { inputList = [], openSticky, isHaveFilterSave, isLoading, filterRef, segmentFloatStickySyncId } = props;
  const [contentWidth, setContentWidth] = useState(defaultContentWidth);
  /** 滚动触发的筛选器吸顶 */
  const [scrollSticky, setScrollSticky] = useState(false);
  /** SegmentScrollCo 浮动吸顶联动 */
  const [segmentSticky, setSegmentSticky] = useState(false);
  const segmentStickyRef = useRef(false);
  const [isExpand, setIsExpand] = useState(false); // 是否展开
  const [isVisiable, setIsVisiable] = useState(false); // 是否展开
  const [openTransition, setOpenTransition] = useState(false); // 开启动画

  const mergedSticky = scrollSticky || segmentSticky;

  useEffect(() => {
    segmentStickyRef.current = segmentSticky;
  }, [segmentSticky]);

  useEffect(() => {
    if (!openSticky || !segmentFloatStickySyncId) {
      return;
    }
    const onSync = (e: Event) => {
      const ce = e as CustomEvent<ISegmentFloatStickySyncDetail>;
      const d = ce.detail;
      if (!d || d.syncId !== segmentFloatStickySyncId) {
        return;
      }
      setSegmentSticky(d.stuck);
    };
    window.addEventListener(
      SEGMENT_FLOAT_STICKY_SYNC_EVENT,
      onSync as EventListener,
    );
    return () => {
      window.removeEventListener(
        SEGMENT_FLOAT_STICKY_SYNC_EVENT,
        onSync as EventListener,
      );
    };
  }, [openSticky, segmentFloatStickySyncId]);

  useEffect(() => {
    if (!openSticky || !segmentFloatStickySyncId) {
      return;
    }
    let t: ReturnType<typeof setTimeout> | undefined;
    if (segmentSticky) {
      setIsVisiable(true);
      setOpenTransition(true);
    } else if (!scrollSticky) {
      setIsVisiable(false);
      t = setTimeout(() => {
        setOpenTransition(false);
      }, 300);
    }
    return () => {
      if (t) {
        clearTimeout(t);
      }
    };
  }, [segmentSticky, scrollSticky, openSticky, segmentFloatStickySyncId]);

  const sizeInfo = useMemo(() => {
    if (!openSticky) {
      return {}
    }
    // 计算筛选器行数
    const cardPadding  = CARD_PADDING * 2;
    let filterLines = 1;
    let filterWidth = isHaveFilterSave ? FILTER_WIDTH.default : 0;
    const canUseContainerWidth = contentWidth - cardPadding - (PAGE_PADDING * 2)- SCROLL_BAR_WIDTH;
    inputList.map((item: any) => {
      if (item.visible === 1) {
        const { type, key, rangePrefix } = item;

        const rType = type || key;
        let itemWidth = FILTER_WIDTH[rType] || FILTER_WIDTH.default;
        if (type === 'rangeDate' && rangePrefix) {
          itemWidth += FILTER_WIDTH.rangePrefix;
        }

        if (rType)
        if (filterWidth + itemWidth > canUseContainerWidth) {
          filterLines += 1;
          filterWidth = itemWidth;
        } else {
          filterWidth += itemWidth;
        }
      }
    });
    // const cardPadding  = CARD_PADDING * 2;
    // // 计算页面筛选中每行可以放多少个筛选器，内容宽度-页面padding-卡片padding-滚动条宽度
    // const pageLineFilterNum = Math.floor((contentWidth - cardPadding - (PAGE_PADDING * 2) - SCROLL_BAR_WIDTH) / FILTER_WIDTH);
    // // 计算头部筛选中每行可以放多少个筛选器，内容宽度-卡片padding，因为fixed布局，不用计算滚动条宽度
    // const headerLineFilterNum = Math.floor((contentWidth - cardPadding) / FILTER_WIDTH);

    // 计算高度信息
    const pageFilterHeight = filterLines * FILTER_HEIGHT + BUTTON_HEIGHT + cardPadding;
    // const headerFilterHeight = Math.ceil(filterNum / (headerLineFilterNum || 1)) * FILTER_HEIGHT + BUTTON_HEIGHT + cardPadding;

    return {
      pageFilterHeight,
      // headerFilterHeight
    };
  }, [contentWidth, inputList, isHaveFilterSave]);

  useEffect(() => {
    if (!openSticky || isLoading) return;
    // 监听window resize，设置筛选器高度
    const handleResize = throttle(() => {
      const clientWidth = document.documentElement.clientWidth;
      const menuWidth = document.getElementsByClassName('dtb-db-left-menu-container')?.[0]?.clientWidth || DEFAULT_MENU_WIDTH;
      setContentWidth(clientWidth - menuWidth - SPLIT_WITH);
    }, 500, {trailing: true})
    window.addEventListener('resize', handleResize);

    // 监听滚动事件，设置筛选器状态
    let outScrollTop = 0;
    // const scrollFlag = 400;
    let outIsSticky = false;
    let trueSticky = false;
    const handleScroll = throttle((e: any) => {
      const { top = 0, height = 0 } = getOffset(filterRef.current);
      const scrollTop = e.target.scrollTop;
      const scrollFlag = top + height + scrollTop + 160;
      const isDown = scrollTop > outScrollTop;
      outScrollTop = scrollTop;
      if (isDown && scrollTop > scrollFlag && !outIsSticky) {
        outIsSticky = true;
        trueSticky = true;
        setScrollSticky(true);
        setTimeout(() => {
          setOpenTransition(true);
        }, 100);
        setTimeout(() => {
          setIsVisiable(true);
        }, 150);
      } else if (!isDown && scrollTop < scrollFlag) {
        // 取消吸顶
        if (outIsSticky) {
          if (!segmentStickyRef.current) {
            setIsVisiable(false);
          }
          outIsSticky = false;
          setTimeout(() => {
            setScrollSticky(false);
            if (!segmentStickyRef.current) {
              setOpenTransition(false);
            }
          }, 300);
        } else if (trueSticky && scrollTop < 280) {
          trueSticky = false;
          setScrollSticky(false);
          if (!segmentStickyRef.current) {
            setOpenTransition(false);
          }
        }
      }
    }, 50);
    const scorllBody = document.getElementsByClassName('dbd-scroll-body')[0]
    scorllBody && scorllBody.addEventListener('scroll', handleScroll);

    return () => {
      if (openSticky) {
        window.removeEventListener('resize', handleResize);
        scorllBody && scorllBody.removeEventListener('scroll', handleScroll);
      }
    }
  }, [isLoading]);

  const handleOpenExpand = () => {
    if (!openSticky || !mergedSticky) {
      return;
    }
    setIsExpand(true);
  }

  const handleCloseExpand = () => {
    if (!openSticky || !mergedSticky) {
      return;
    }
    setIsExpand(false);
  }

  const { pageFilterHeight } = sizeInfo;
  return {
    isSticky: mergedSticky,
    isExpand,
    isVisiable,
    openTransition,
    handleOpenExpand,
    handleCloseExpand,
    pageFilterHeight,
  }
}
